module.exports = __webpack_public_path__ + "img/menu_btn.854f9538.png";